import React, { useEffect } from "react"

import "../../../style/saas-setup-tab.module.css"
import Storage from "../../../utils/storage"
import { AUTO_CREATE_PROD_APP } from "../../../utils/payments"

interface Props {
  handleCreateProdEnv: () => void
}

const ProdEmptySetupTab = (props: Props) => {

  useEffect(()=>{
    const autoCreateProdApp = Storage.getItem(AUTO_CREATE_PROD_APP)
    if(typeof autoCreateProdApp === "string" && autoCreateProdApp === "true"){
      Storage.removeItem(AUTO_CREATE_PROD_APP);
      props.handleCreateProdEnv()
    }
  },[])
  
  return (
    <div className="setup-tab">
      <p>
        You have not created a production environment for this app.
      </p>

      <button
        className="yellow-button yellow-button__empty-prod-tab"
        onClick={props.handleCreateProdEnv}
      >
        Create production env
      </button>
    </div>
  )
}

export default ProdEmptySetupTab
